<template>
  <service-autocomplete
    :search-attributes-array="['name', 'author_original_id']"
    :value="value"
    v-bind="$attrs"
    ref="autocomplete"
    @input="handleInputChange"
    :url="url"
    cache-items
    multiple
    :use-entities="false"
    :baseAndQueryParams="queryParams"
  >
    <template v-slot:item="{ item }">
      <v-list-item-avatar color="primary" class="font-weight-light white--text">
        {{ item.organisation }}
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ item.name + ' - ' + item.author_original_id }}
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        {{ generateMessage(`authors.type.${item.type}`) }}
      </v-list-item-action>
    </template>
    <template v-slot:selection="{ attrs, selected, item }">
      <v-chip
        v-bind="attrs"
        :value="selected"
        close
        small
        @click:close="$refs.autocomplete.handleInputRemove(item)"
      >
        {{
          item.name + ' (' + generateMessage(`authors.type.${item.type}`) + ')'
        }}
      </v-chip>
    </template>
  </service-autocomplete>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import ServiceAutocomplete from '@/components/selects/ServiceAutocomplete';
import createTechnicianSimpleRequest from '@/components/selects/technician/technicianReusableBaseRequest';
import AuthorsAPI from '@/services/api/internal/authors.api';

export default {
  name: 'custom-authors-selector',
  components: { ServiceAutocomplete },
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      url: AuthorsAPI.url,
      queryParams: [
        {
          $or: [
            {
              end_date: {
                $gte: { $date: new Date().toISOString() },
              },
            },
            {
              end_date: { $null: null },
            },
            {
              end_date: {
                $lte: { $date: '1000-01-01T00:00:00.000Z' },
              },
            },
          ],
        },
      ],
    };
  },
  methods: {
    generateMessage,
    createTechnicianSimpleRequest,
    handleInputChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>
